import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class PolicyListDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.PolicySummary, Model.Bookings.Logic.ViewModels.PolicySummary, PolicySummary> {
	protected map(entity: Model.Bookings.Logic.ViewModels.PolicySummary): PolicySummary {
		return new PolicySummaryModel(entity);
	}

	static make(ctx?: any): PolicyListDataService {
		return new PolicyListDataService(ctx, ctx => ctx.PolicySummaries);
	}
}

export class PolicySummaryModel extends EntityModel<Model.Bookings.Logic.ViewModels.PolicySummary, PolicySummary> implements PolicySummary {
	@property<PolicySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<PolicySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<PolicySummaryModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<PolicySummaryModel>(o => o.entity.commission, (o, value) => o.entity.commission = value)
	public commission: number;

	@property<PolicySummaryModel>(o => o.entity.hasRules, (o, value) => o.entity.hasRules = value)
	public hasRules: boolean;
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/list/policy-list.data.ts